import {BehaviorSubject, Observable} from 'rxjs';
import {NGXLogger} from "ngx-logger";

/**
 * Storage service
 * used for persist application data in observable key value pair
 */
export class StorageService {
  private storage: Storage;
  private subjects: Map<string, BehaviorSubject<any>>;

  /**
   * Constructor with service injection
   * @param storage
   */
  constructor(storage: Storage, private logger : NGXLogger) {
    this.storage = storage;
    this.subjects = new Map<string, BehaviorSubject<any>>();
  }

  /**
   * watch data of given key
   * @param key
   * @param defaultValue
   */
  watch(key: string): Observable<any> | undefined {
    if (!this.subjects.has(key)) {
      this.subjects.set(key, new BehaviorSubject<any>(null));
    }
    let item  = this.storage.getItem(key);
    if (item === "undefined" || item == null) {
      item = null;
    } else {
      item = JSON.parse(item as string);
    }
    this.subjects.get(key)?.next(item);
    return this.subjects.get(key)?.asObservable();
  }

  /**
   * get data of given key
   * @param key
   */
  get(key: string): any {
    let item = this.storage.getItem(key);
    if (item === "undefined" || item == null) {
      item = null;
    } else {
      item = JSON.parse(item as string);
    }
    return item;
  }

  /**
   * set value on given key
   * @param key
   * @param value
   */
  set(key: string, value: any) {
    this.logger.debug("Adding Storage Key + " + key + " Value= " + value)
    this.storage.setItem(key, JSON.stringify(value));
    if (!this.subjects.has(key)) {
      this.subjects.set(key, new BehaviorSubject<any>(value));
    } else {
      this.subjects.get(key)?.next(value);
    }
    this.logger.debug("StorageLen = " + this.storage.length);
  }

  /**
   * remove given key
   * @param key
   */
  remove(key: string) {
    if (this.subjects.has(key)) {
      this.subjects.get(key)?.complete();
      this.subjects.delete(key);
    }
    this.storage.removeItem(key);
  }

  /**
   * clear all available keys
   */
  clear() {
    this.subjects.clear();
    this.storage.clear();
    this.logger.debug("Cleared Storage");
  }
}
